import {Styles} from '@chakra-ui/theme-tools';

const styles: Styles = {};

export default styles;
